import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label, Toggle } from '@fluentui/react';
import { useId } from '@fluentui/react-hooks';
/**
 * This is a Fluent Toggle that takes a feature key, label, and description.
 */
export const FeaturePanelToggle = ({ description, featureName, label, isLoading, onChange, enabled, }) => {
    const idDesc = useId(`description-${featureName}`);
    const idToggle = useId(`toggle-${featureName}`);
    return (_jsxs("div", { children: [_jsx(Label, Object.assign({ htmlFor: idToggle }, { children: label })), _jsx("div", Object.assign({ id: idDesc }, { children: description })), _jsx(Toggle, { id: idToggle, "aria-describedby": idDesc, onText: 'Enabled', offText: 'Disabled', checked: enabled, disabled: isLoading, styles: { root: { paddingTop: '4px', paddingBottom: '4px' } }, onChange: (_, checked) => {
                    onChange === null || onChange === void 0 ? void 0 : onChange(checked);
                } })] }));
};
